import { render, staticRenderFns } from "./AuthLoginThirdPartyGroupButtons.vue?vue&type=template&id=401c1db7&"
import script from "./AuthLoginThirdPartyGroupButtons.vue?vue&type=script&lang=ts&"
export * from "./AuthLoginThirdPartyGroupButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports